
import { FC } from 'react';

interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const Logo: FC<LogoProps> = ({ className = '', size = 'md' }) => {
  const sizeClasses = {
    sm: 'text-xl',
    md: 'text-2xl',
    lg: 'text-4xl'
  };

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div className="relative">
        <div className="w-12 h-12 rounded-full bg-gradient-to-br from-red-600 to-blue-600 flex items-center justify-center shadow-lg">
          <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center">
            <div className="w-6 h-6 rounded-full bg-gradient-to-br from-red-500 via-white to-blue-500 border border-gray-200"></div>
          </div>
        </div>
      </div>
      <div className="flex flex-col">
        <h1 className={`font-bold text-gray-800 ${sizeClasses[size]} leading-tight`} style={{ fontFamily: 'Noto Sans KR, sans-serif' }}>
          815광복점
        </h1>
        <span className="text-xs text-gray-600 font-medium">프리미엄 한식 전문점</span>
      </div>
    </div>
  );
};

export default Logo;
